/** Consistent font stacks for English vs Urdu (Noori-Nastaliq) across MUI, Chart.js, and CSS. */
export const FONT_STACK_EN = '"Parkinsans", sans-serif';
/** Latin first (per-glyph): English keeps Parkinsans; Urdu/Arabic uses Noori where Parkinsans has no glyph. */
export const FONT_STACK_UR = '"Parkinsans", "Noori-Nastaliq", sans-serif';

export function getFontStackForLanguage(language) {
  const normalized = String(language || "")
    .split(/[-_]/)[0]
    .toLowerCase();
  return normalized === "ur" ? FONT_STACK_UR : FONT_STACK_EN;
}
